function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { ThemeConsumer } from "../ThemeProvider/ThemeContext";
import { BreakpointsContext } from "../Breakpoints/BreakpointsProvider";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { toMediaQuery, toMaxMediaQuery, carinaFontReset } from "./styles/index";
import { deprecatedPropValueMessage } from "../../utils/deprecationUtils";
var FORM_HEADING_SECTION_WIDTH = 200;
export var isFormSectionChild = function(child) {
    return !!child && !!child.type && (child).type.layoutId === 'FormSection';
};
var _Component;
export var FormSection = function(_superClass) {
    "use strict";
    _inherits(FormSection, _superClass);
    var _super = _createSuper(FormSection);
    function FormSection() {
        _classCallCheck(this, FormSection);
        var _this;
        _this = _super.apply(this, arguments);
        _this.getStackBreakpoint = function() {
            var ref;
            var stackBreakpoint = _this.props.stackBreakpoint;
            if (stackBreakpoint) {
                return stackBreakpoint;
            }
            return (ref = _this.context) === null || ref === void 0 ? void 0 : ref.m;
        };
        _this.renderHeader = function(theme) {
            return _jsx("div", {
                css: [
                    getHeaderStyles(theme, _this.props, _this.getStackBreakpoint()),
                    carinaFontReset(theme)
                ],
                children: _jsx("h3", {
                    css: {
                        fontSize: theme.font.base.size.h3,
                        lineHeight: theme.font.lineHeight.heading,
                        fontWeight: theme.font.base.weight.regular,
                        fontFamily: theme.font.base.family,
                        color: theme.font.color.base
                    },
                    children: _this.props.heading
                })
            });
        };
        _this.renderContent = function(theme) {
            return _jsx("div", {
                css: getContentStyles(theme, _this.props, _this.getStackBreakpoint()),
                children: _this.renderRowsWithSharedProps(_this.props)
            });
        };
        _this.renderRowsWithSharedProps = function(param) {
            var children = param.children, isRtl = param.isRtl;
            return React.Children.map(children, function(element) {
                return React.cloneElement(element, {
                    isRtl: isRtl
                });
            });
        };
        return _this;
    }
    var _proto = FormSection.prototype;
    _proto.componentDidUpdate = function componentDidUpdate() {
        if (this.props.hideHeading) {
            deprecatedPropValueMessage({
                componentName: 'FormSection',
                propName: 'hideHeading',
                date: 'v1 migration',
                propValue: this.props.hideHeading
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, testID = _props.testID, accessibilityLabel = _props.accessibilityLabel, _stackBreakpoint = _props.stackBreakpoint, _heading = _props.heading, hideHeading = _props.hideHeading, _isRtl = _props.isRtl, _stack = _props.stack, _css = _props.css, _style = _props.style, _className = _props.className, propDrop = _objectWithoutProperties(_props, [
            "testID",
            "accessibilityLabel",
            "stackBreakpoint",
            "heading",
            "hideHeading",
            "isRtl",
            "stack",
            "css",
            "style",
            "className"
        ]);
        return _jsx(ThemeConsumer, {
            children: function(theme) {
                return _jsxs("div", _objectSpread({}, propDrop, injectTestId(testID), {
                    css: getContainerStyles(theme, _this.props, _this.getStackBreakpoint()),
                    "aria-label": accessibilityLabel,
                    children: [
                        !hideHeading && (_this.props.heading || _this.props.heading === '') && _this.renderHeader(theme),
                        _this.renderContent(theme)
                    ]
                }));
            }
        });
    };
    _createClass(FormSection, null, [
        {
            key: "layoutId",
            get: function get() {
                return FormSection._layoutId;
            }
        }
    ]);
    return FormSection;
}(_Component = React.Component);
FormSection._layoutId = 'FormSection';
FormSection.contextType = BreakpointsContext;
function getContainerStyles(theme, param, stackBreakpoint) {
    var isRtl = param.isRtl, stack = param.stack;
    return _objectSpread({
        display: 'flex',
        flexDirection: 'column'
    }, toMediaQuery(stackBreakpoint, {
        flexDirection: stack ? 'column' : isRtl ? 'row-reverse' : 'row',
        borderBottomWidth: theme.size.border.base,
        borderBottomColor: theme.borderColor.base,
        borderBottomStyle: 'solid',
        ':last-child': {
            borderColor: 'transparent'
        }
    }));
}
function getHeaderStyles(theme, param, stackBreakpoint) {
    var isRtl = param.isRtl, stack = param.stack;
    return _objectSpread({
        color: theme.font.color.base,
        direction: isRtl ? 'rtl' : 'ltr'
    }, toMediaQuery(stackBreakpoint, stack ? {} : {
        width: FORM_HEADING_SECTION_WIDTH
    }));
}
function getContentStyles(theme, param, stackBreakpoint) {
    var isRtl = param.isRtl, stack = param.stack, hideHeading = param.hideHeading;
    return _objectSpread({
        flex: stack ? '1 0 auto' : '1 0 0%',
        paddingTop: theme.spacing[5],
        paddingBottom: theme.spacing[5]
    }, toMediaQuery(stackBreakpoint, _defineProperty({}, isRtl ? 'paddingRight' : 'paddingLeft', stack || hideHeading ? 0 : theme.spacing[6])), toMaxMediaQuery(stackBreakpoint, {
        flex: '1 0 auto'
    }));
}
export default FormSection;
